import VaccineCard from "../components/VaccineCard";
import { makeStyles } from "@material-ui/core/styles";
import { Backdrop, Button, CircularProgress } from "@material-ui/core";
import { useContext, useEffect } from "react";
import { AppContext } from "../AppContext";

const useStyles = makeStyles({
  title: {
    fontSize: "2rem",
    fontWeight: "200",
    marginTop: "20px",
  },
  registerBtn: {
    marginBottom: "20px",
    alignSelf: "center",
    textTransform: "none",
    minHeight: "max-content",
  },
  note: {
    padding: "20px",
    maxWidth: "500px",
    alignSelf: "center",
  },
  high: {
    zIndex: 2000,
  },
});

const Vacunas = () => {
  const classes = useStyles();
  const { vaccines, setVaccines } = useContext(AppContext);

  useEffect(() => {
    const fetchVaccines = async () => {
      if (vaccines) return;

      const res = await fetch(
        "https://api-sinaloa-covid-app.netlify.app/vaccines.json"
      );
      let data = await res.json();
      setVaccines(data);
      console.log(data);
    };
    fetchVaccines();
  }, [vaccines, setVaccines]);

  return (
    <>
      {vaccines ? (
        <>
          <p className={classes.title}>Vacunación</p>
          <p className={classes.note}>
            <strong>Fuente:</strong> DelegaciónSinMx
          </p>
          <Button
            variant="contained"
            color="secondary"
            className={classes.registerBtn}
            onClick={() =>
              window.open("https://mivacuna.salud.gob.mx/index.php")
            }
          >
            Registrarse
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.registerBtn}
            onClick={() => window.open("https://cvcovid.salud.gob.mx/")}
          >
            Comprobante
          </Button>
          {vaccines.vaccines.map((vaccine, idx) => (
            <VaccineCard key={idx} {...vaccine} />
          ))}
        </>
      ) : (
        <Backdrop open={true} className={classes.high}>
          <CircularProgress color="primary" className={classes.high} />
        </Backdrop>
      )}
    </>
  );
};

export default Vacunas;
